let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bZ2zV")).then(() => parcelRequire('4kw1b'));